/**
 * 判断是否是小程序环境 
 */
export function IsMiniProgramEnv (callback) {
  if (!isWeixin()) {
    callback(false)
    return
  }
  wx.miniProgram.getEnv((res) => {
    if (res.miniProgram) {
      callback(true)
    } else {
      callback(false)
    }
  })
}

/**
 * 判断是否在微信浏览器打开
 * @returns 
 */
export function isWeixin () {
  const ua = window.navigator.userAgent.toLowerCase();
  return (ua.match(/MicroMessenger/i) == 'micromessenger' || ua.match(/_SQ_/i) == '_sq_')
}